import {typeOptions, alignmentOptions, sizeOptions, bookOptions, spellCastingOptions,} from '../../constants'
import { useRef, useEffect } from 'react';

import 'react-tabs/style/react-tabs.css';
import SearchOptionsDropdown from './SearchOptionsDropdown'
import 'react-range-slider-input/dist/style.css';
import Slider from '@mui/material/Slider';


const Filters = ({filterType, setFilterType, filterSource, setFilterSource, filterAlignment, setFilterAlignment, filterSize, setFilterSize, filterCrRange, setFilterCrRange, filterSpellcasting, setFilterSpellcasting, filtersOpen, setFiltersOpen}) => {
    const filterRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (filterRef.current && !filterRef.current.contains(event.target)) setFiltersOpen(false);
        };

        if(filtersOpen) document.addEventListener('mousedown', handleClickOutside)
        else document.removeEventListener('mousedown', handleClickOutside);
        return () => { document.removeEventListener('mousedown', handleClickOutside); };
    }, [filtersOpen]);

    const handleCrRange = (e, newRange) => {
        setFilterCrRange([...newRange]);
    };

    return (
        <div className='filterDetails' ref={filterRef}>
            <div style={{cursor: 'pointer', margin: 0, display: 'flex', alignItems: 'center'}} onClick={() => setFiltersOpen(!filtersOpen)}>
                <b style={{fontSize: '1.1rem'}}>Filters</b>
                <svg width="16" height="16" viewBox="0 0 16 16" style={{
                    verticalAlign: "middle",
                    transition: "transform 0.2s",
                    transform: filtersOpen ? "rotate(0deg)" : "rotate(90deg)"
                }}>
                    <polyline points="4,6 8,10 12,6" fill="none" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </div>

            {filtersOpen &&
                <div className='searchFilterSummaryContainer'> 
                    <div className='searchFilterSummary'>
                        <div className='searchOptionDropdownsContainer'>
                            <SearchOptionsDropdown label={'Type'} options={typeOptions} values={filterType} setFilter={setFilterType}/>
                            <SearchOptionsDropdown label={'Size'} options={sizeOptions} values={filterSize} setFilter={setFilterSize}/>
                            <SearchOptionsDropdown label={'Alignment'} options={alignmentOptions} values={filterAlignment} setFilter={setFilterAlignment}/>
                            <SearchOptionsDropdown label={'Source'} options={bookOptions} values={filterSource} setFilter={setFilterSource}/>
                            <SearchOptionsDropdown label={'Spellcasting'} options={spellCastingOptions} values={filterSpellcasting} setFilter={setFilterSpellcasting}/>
                        </div> 
                        <div className='searchOptionCrFill'> 
                            <i className="searchOptionBlockTitle crOptionTitle">CR
                                <div className='sliderContainer'>
                                    <Slider
                                        step={1}
                                        value={filterCrRange}
                                        onChange={handleCrRange}
                                        valueLabelDisplay="off"
                                        min={0}
                                        max={30}
                                    />
                                </div>
                            </i>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}

export default Filters;